<div class="agpr-emailRecipientCard">
    <div class="agpr-emailRecipientCard-mainCard">
        <div class="agpr-emailRecipientCard-thumbnail">
            <img
                height="75"
                width="75"
                [agprDefaultImage]="imageDefault.SMALL_CONTACT"
                alt=""
            />
        </div>
        <div class="agpr-emailRecipientCard-mainInfo">
            <div
                class="agpr-emailRecipientCard-name"
                [agprTooltip]="name"
                tooltipPosition="top"
            >
                {{ name }}
            </div>
            <div class="agpr-emailRecipientCard-emailAndStatus">
                <div
                    class="agpr-emailRecipientCard-email"
                    [agprTooltip]="email"
                    tooltipPosition="top"
                >
                    {{ email }}
                </div>
            </div>
        </div>
    </div>
    <div class="agpr-emailRecipientCard-actions">
        <div class="agpr-emailRecipientCard-status">
            {{ status | localize}}
        </div>
        <agpr-button
            class="agpr-emailRecipientCard-toggle"
            [style]="buttonTypes.icon"
            [icon]="expanded ? 'fa-solid fa-angle-up' : ' fa-solid fa-angle-down'"
            tooltip="Briefings.sentReport.toggleStatus"
            (keydown)="toggle($event)"
            (click)="toggle()"
        ></agpr-button>
    </div>

    <div
        *ngIf="expanded && (otherEvents.length + linkEvents.length) > 0"
        class="agpr-emailRecipientCard-subCard"
    >
        <div *ngFor="let emailEvent of otherEvents">
            <div class="agpr-emailRecipientCard-emailEvent">
                <span class="agpr-emailRecipientCard-emailEvent-type">{{topStatLabels.get(emailEvent.type) | localize}}</span>
                <span class="agpr-emailRecipientCard-emailEvent-date">{{emailEvent.date}}</span>
            </div>
        </div>

        <ng-container *ngIf="linkEvents.length > 0">
            <div class="agpr-emailRecipientCard-emailEvent agpr-emailRecipientCard-emailEvent-category">
                <span class="agpr-emailRecipientCard-emailEvent-type">{{'Discover.distributionReport.recipientCards.events.linkClicked' | localize}}</span>
            </div>
            <div *ngFor="let emailEvent of linkEvents">
                <div class="agpr-emailRecipientCard-emailEvent">
                    <a
                        class="agpr-emailRecipientCard-emailEvent-url"
                        [href]="emailEvent.clickedUrl"
                        target="_blank"
                    >
                        {{emailEvent.clickedUrl}}
                    </a>
                    <span class="agpr-emailRecipientCard-emailEvent-date">{{emailEvent.date }}</span>
                </div>
            </div>
        </ng-container>
    </div>
</div>
